import fertigationDataConfig from '@/api/config/fertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

function useDetailFertigationGlobal(interfaceId: number) {
  return useQuery({
    queryKey: [queryKeys.fertigationId, interfaceId],
    queryFn: async () => {
      const { data } = await fertigationDataConfig.getGlobalSettings(
        interfaceId,
      )
      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
    // enabled: !!interfaceId,
  })
}

export default useDetailFertigationGlobal
